import OnLoadScrollToEl from "./onLoadScrollTo";

export const onLoadScrollTo = {
    init: () => {
      const scrollToEl = document.querySelector(".sd-scroll-to-el");
      if (scrollToEl) {
        new OnLoadScrollToEl(scrollToEl);
      }
    }
}

export default onLoadScrollTo;